export const icons = {
  _customers: require("./new/_customers.png"),
  _notes: require("./new/_notes.png"),
  _factors: require("./new/_factors.png"),
  _categories: require("./new/_categories.png"),
  _products: require("./new/_products.png"),
  _attributes: require("./new/_attributes.png"),
  _reminders: require("./new/_reminders.png"),
  _organization: require("./new/_organization.png"),
  _employee_01: require("./new/_employee_01.png"),
  _employee_02: require("./new/_employee_02.png"),
  _employee_03: require("./new/_employee_03.png"),
  _employee_04: require("./new/_employee_04.png"),
  _role: require("./new/_role.png"),
  _plus: require("./new/_plus.png"),
  _smartphone: require("./new/_smartphone.png"),
  _dot: require("./new/_dot.png"),
  _hands: require("./new/_hands.png"),
  _no_entry: require("./new/_no_entry.png"),
  _filter: require("./new/_filter.png"),

  user: require("./bazar.png"),

  products: require("./products.png"),
  sellers: require("./sellers.png"),
  customers: require("./customers.png"),
  reminders: require("./reminders.png"),
  notes: require("./notes.png"),
  factors: require("./factors.png"),
  sales: require("./sales.png"),
  plus: require("./plus.png"),

  seller_icon: require("./seller_icon.png"),

  home: require("./home.png"),
  history: require("./history.png"),
  profile: require("./profile.png"),
  reports: require("./reports.png"),
  pin: require("./pin.png"),

  brand: require("./brand.png"),
  company: require("./company.png"),
  office: require("./office.png"),

  focus: require("./focus.png"),
  send: require("./send.png"),

  play: require("./play.png"),
  pause: require("./pause.png"),
  record: require("./record.png"),
  pause_record: require("./stop-record.png"),

  waves: require("./waves.png"),

  mic: require("./mic.png"),
  attach: require("./attach.png"),

  check: require("./check.png"),
  clock: require("./clock.png"),
};
